import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import Styles from './PostPreviewModal.module.scss'
import { BlazeInverted, Edit3, LinkAngled } from 'blaze-ui/icons'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { Button } from 'blaze-ui/Button'
import { ArrowOut } from 'almanac-ui/icons'
import { ProviderIcon } from './ProviderIcon'
import { FacebookNotice } from 'components/IntegrationInitialization/FacebookInitialization/FacebookInitialization'
import { InstagramNotice } from 'components/IntegrationInitialization/InstagramInitialization/InstagramInitialization'
import { useInitiateOauth } from 'hooks/useInitiateOauth'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { DOC_PATH } from 'paths'
import { DESIGN_PATH } from 'paths'
import { generatePath } from 'react-router-dom'
import { usePostPreviewContext } from './PostPreviewContext'

interface Props {
  provider: ExternalIntegrationEnum
  providerName: string
  fileId: string
}

const Notice = ({ provider }: { provider: ExternalIntegrationEnum }) => {
  switch (provider) {
    case ExternalIntegrationEnum.Facebook:
      return <FacebookNotice />
    case ExternalIntegrationEnum.Instagram:
      return <InstagramNotice />

    default:
      return null
  }
}

const buttonTextFromProviderType: Partial<Record<ExternalIntegrationEnum, string>> = {
  [ExternalIntegrationEnum.Facebook]: 'Go to Facebook Business',
  [ExternalIntegrationEnum.Instagram]: 'Go to Facebook Business',
  [ExternalIntegrationEnum.LinkedIn]: 'Go to LinkedIn',
  [ExternalIntegrationEnum.X]: 'Go to X/Twitter',
  [ExternalIntegrationEnum.TikTok]: 'Go to TikTok',
}

export const NoIntegration = ({ provider, providerName, fileId }: Props) => {
  const { initiateOauth } = useInitiateOauth()
  const { scheduledPost } = usePostPreviewContext()

  let to = generatePath(DESIGN_PATH, { key: fileId })
  if (scheduledPost?.almanac_file.type === 'article') to = generatePath(DOC_PATH, { slug: fileId })

  const handleConnectAccount = () => {
    initiateOauth(provider)
  }

  return (
    <div className={Styles.noIntegrationContainer}>
      <div className={Styles.integrationIcons}>
        <ProviderIcon provider={provider} size={40} />
        <LinkAngled />
        <BlazeInverted size={40} />
      </div>
      <Heading level={4}>First, connect your account.</Heading>
      <Text variant="secondary" color="var(--neutral-90)">
        We're sending you to {providerName} real quick to sign in and link your account to Blaze.
      </Text>
      <Notice provider={provider} />
      <Button size="lg" variant="primary" endIcon={ArrowOut} onPress={handleConnectAccount}>
        {buttonTextFromProviderType[provider]}
      </Button>
      <ButtonLink to={to} size="lg" variant="tertiary" frontIcon={Edit3}>
        Edit Content
      </ButtonLink>
    </div>
  )
}
